const Applicant = ({ name = '', status = '' } = {}) => ({
  name: String(name),
  status: String(status),
});

const Application = ({
  applicationId = '',
  conversationId = '',
  statusUpdatedTimestamp = 0,
  statusType = '',
  applicants = [],
  applicationIsViewed = false,
} = {}) => ({
  applicationId: String(applicationId),
  conversationId: String(conversationId),
  statusUpdatedTimestamp: Number(statusUpdatedTimestamp),
  statusType: String(statusType),
  applicants: applicants.map(Applicant),
  applicationIsViewed: Boolean(applicationIsViewed),
});

const RentalApplicationData = ({
  totalNumberOfApplications = 0,
  totalNumberOfApplicationsFetched = 0,
  totalNumberOfInvitedApplications = 0,
  totalNumberOfWithdrawnApplications = 0,
  totalNumberOfDeclinedApplications = 0,
  totalNumberOfActiveApplications = 0,
  applicationList = [],
} = {}) => ({
  // totalNumberOfApplications is the same as totalNumberOfActiveApplications. totalNumberOfApplications excludes withdrawn and invited apps, so it is really only returning Number of Active Applications. totalNumberOfApplications was the first key to be made but BE didn't want to get rid of it so instead added more specific keys to describe number of applications
  totalNumberOfApplications: Number(totalNumberOfApplications),
  totalNumberOfApplicationsFetched: Number(totalNumberOfApplicationsFetched),
  totalNumberOfInvitedApplications: Number(totalNumberOfInvitedApplications),
  totalNumberOfWithdrawnApplications: Number(totalNumberOfWithdrawnApplications),
  totalNumberOfDeclinedApplications: Number(totalNumberOfDeclinedApplications),
  totalNumberOfActiveApplications: Number(totalNumberOfActiveApplications),
  applicationList: applicationList.map(Application),
});

const RemainingSummaryCount = ({ remainingCount = 0, remainingCountNew = 0 } = {}) => ({
  remainingCount: Number(remainingCount),
  remainingCountNew: Number(remainingCountNew),
});

const UserManagementFlags = ({
  canEnableApplications = false,
  canRequestAccess = false,
  isPermissionRequestSent = false,
  isApplicationPermissionsEnabledForCompany = false,
  isEligible = false,
} = {}) => ({
  canEnableApplications: Boolean(canEnableApplications),
  canRequestAccess: Boolean(canRequestAccess),
  isPermissionRequestSent: Boolean(isPermissionRequestSent),
  isApplicationPermissionsEnabledForCompany: Boolean(isApplicationPermissionsEnabledForCompany),
  isEligible: Boolean(isEligible),
});

const InviteOnly = ({ isInviteOnlyEnabled = false, isInviteOnly = false } = {}) => ({
  isInviteOnlyEnabled: Boolean(isInviteOnlyEnabled),
  isInviteOnly: Boolean(isInviteOnly),
});

const ApplicationSummary = ({
  isApplicationsAccepted = false,
  isApplicationsAccessRestricted = false,
  isFeed = false,
  listingAlias = '',
  applicationsOwnerEmail = '',
  title = '',
  urlPath = '',
  remainingSummaryCount = {},
  rentalApplicationData = {},
  userManagementFlags = {},
  inviteOnly = {},
} = {}) => ({
  isApplicationsAccepted: Boolean(isApplicationsAccepted),
  isApplicationsAccessRestricted: Boolean(isApplicationsAccessRestricted),
  isFeed: Boolean(isFeed),
  listingAlias: String(listingAlias),
  applicationsOwnerEmail: String(applicationsOwnerEmail),
  urlPath: String(urlPath),
  title: String(title),
  remainingSummaryCount: RemainingSummaryCount(remainingSummaryCount),
  rentalApplicationData: RentalApplicationData(rentalApplicationData),
  userManagementFlags: UserManagementFlags(userManagementFlags),
  inviteOnly: InviteOnly(inviteOnly),
});

export default ApplicationSummary;

export type ApplicationSummaryProps = ReturnType<typeof ApplicationSummary>;
